import React, { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { eventJournalerAtom } from '../../atoms/event-journal-atoms';
import { BufferedEventJournaler } from '../buffered-event-journaler';
type PropsT = {
  children: React.ReactNode;
};
export const BufferedEventJournalerInitializer = ({
  children
}: PropsT) => {
  const setEventJournaler = useSetAtom(eventJournalerAtom);
  useEffect(() => {
    const journaler = new BufferedEventJournaler();
    setEventJournaler(journaler);
    return () => {
      setEventJournaler(null);
    };
  }, [setEventJournaler]);
  return <>{children}</>;
};